import { useContractGameStore } from '../store/useContractGameStore'
import { ALL_SUITS, ALL_RANKS, STAKEHOLDER_TO_SUIT } from '../data/pokerConfig'
import type { ClueCard, StakeholderId } from '../engine/types'

const BASE_DECK_SIZE = ALL_SUITS.length * ALL_RANKS.length  // 4 × 13 = 52

function countWildExtras(collectedCards: ClueCard[]): number {
  return collectedCards.filter(card => {
    const suit = STAKEHOLDER_TO_SUIT[card.source as StakeholderId | 'synthesis'] ?? 'wild'
    return suit === 'wild'
  }).length
}

export function useDeckInfo() {
  const phase = useContractGameStore(s => s.phase)
  const isInterShop = useContractGameStore(s => s.isInterShop)
  const deck = useContractGameStore(s => s.deck)
  const hand = useContractGameStore(s => s.hand)
  const discardPile = useContractGameStore(s => s.discardPile)
  const playedCards = useContractGameStore(s => s.playedCards)
  const collectedCards = useContractGameStore(s => s.collectedCards)

  // 初始 PACK_SHOP: deck 还未构建，按 52 + wild 额外牌数计算
  if (phase === 'PACK_SHOP' && !isInterShop) {
    const projected = BASE_DECK_SIZE + countWildExtras(collectedCards)
    return { deckSize: projected, totalSize: projected }
  }

  // 其他阶段: 使用实际 deck 状态
  const totalSize = deck.length + hand.length + discardPile.length + playedCards.length
  return { deckSize: deck.length, totalSize }
}
